import { render, staticRenderFns } from "./ingredientTemplate.vue?vue&type=template&id=0f34d866&scoped=true"
import script from "./ingredientTemplate.vue?vue&type=script&lang=js"
export * from "./ingredientTemplate.vue?vue&type=script&lang=js"
import style0 from "./ingredientTemplate.vue?vue&type=style&index=0&id=0f34d866&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f34d866",
  null
  
)

export default component.exports